import React, { memo } from 'react';

import SiteMarker from '@components/Map/Markers/SiteMarker';

import { isEqual } from '@utils/common';

import { TAsset } from '@interfaces/assets/asset';
import { ISiteMarker } from '@interfaces/map/map';

import { EDataType } from '@enums/map';

import AssetMarker from './AssetMarker';

interface IMarkersProps {
	marker: TAsset | ISiteMarker;
	handleClickOnCluster: (marker: TAsset | ISiteMarker) => void;
	setIsVisibleSiteInfo?: (isVisible: boolean) => void;
}

const Markers = ({
	marker,
	handleClickOnCluster,
	setIsVisibleSiteInfo,
}: IMarkersProps) => {
	return (
		marker.dataType === EDataType.assets
			? <AssetMarker
				handleClickOnCluster={handleClickOnCluster}
				marker={marker as TAsset}
			/>
			: <SiteMarker
				handleClickOnCluster={handleClickOnCluster}
				marker={marker as ISiteMarker}
				setIsVisibleSiteInfo={setIsVisibleSiteInfo}
			/>
	);
};

export default memo(Markers, (prevProps, nextProps) => isEqual(prevProps, nextProps));
